/**
 * External dependencies
 */
import { get, filter } from 'lodash';


export default (state, connectionId) => {
    return filter(get(state, ['locationGroups', 'items']), { connection: connectionId });
};